import PT from 'prop-types';

export const DropdownOptionsType = PT.arrayOf(PT.shape({
  key: PT.oneOfType([PT.string, PT.number]).isRequired,
  value: PT.oneOfType([PT.string, PT.number]).isRequired,
  text:PT.oneOfType([PT.string, PT.object]).isRequired,
}));

export const FilterMenuOptionsType = PT.arrayOf(PT.shape({
  name: PT.string.isRequired,
  value: PT.oneOfType([PT.string, PT.number]).isRequired,
}));



// WEBPACK FOOTER //
// ./src/lib/proptypes/semantic.js